import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { MAP_THEME_OPTIONS, normalizeMapTheme } from '../../utils/mapTheme';
import { COLORS } from '../../styles/tokens';

export const THEME_OPTIONS = [
  { value: 'system', label: 'System', hint: 'Følger innstillingen på enheten' },
  { value: 'light',  label: 'Lys' },
  { value: 'dark',   label: 'Mørk' },
];

export const themeLabel = theme => (THEME_OPTIONS.find(o => o.value === theme) ?? THEME_OPTIONS[0]).label;

function RadioGroup({ label, options, value, onChange }) {
  return (
    <div role="radiogroup" aria-label={label}>
      <div style={styles.groupTitle}>{label}</div>
      {options.map(opt => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value} type="button" role="radio" aria-checked={selected}
            onClick={() => onChange(opt.value)}
            style={styles.option}
          >
            <span style={{ ...styles.radio, borderColor: selected ? COLORS.accent : COLORS.border }}>
              {selected && <span style={styles.dot} />}
            </span>
            <span style={{ minWidth: 0 }}>
              <span style={styles.label}>{opt.label}</span>
              {opt.hint && <span style={styles.hint}>{opt.hint}</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}

// Valg for utseende som folder ut i profilen: tema (System/Lys/Mørk) og, når onMapTheme er gitt, kartets farge.
// Valgene gjelder og lagres med en gang.
export default function AppearanceOptions({ mapTheme, onMapTheme }) {
  const { theme, setTheme } = useTheme();
  return (
    <div>
      <RadioGroup label="Tema" options={THEME_OPTIONS} value={theme} onChange={setTheme} />
      {onMapTheme && (
        <div style={{ marginTop: 18 }}>
          <RadioGroup label="Kart" options={MAP_THEME_OPTIONS} value={normalizeMapTheme(mapTheme)} onChange={onMapTheme} />
        </div>
      )}
    </div>
  );
}

const styles = {
  groupTitle: { fontSize: 12, fontWeight: 700, color: COLORS.textLight, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 2 },
  option: { display: 'flex', alignItems: 'center', gap: 14, width: '100%', padding: '12px 0', background: 'none', border: 'none', borderBottom: `1px solid ${COLORS.border}`, textAlign: 'left', fontFamily: 'inherit', color: COLORS.textDark, cursor: 'pointer' },
  radio:  { width: 22, height: 22, borderRadius: '50%', borderWidth: 2, borderStyle: 'solid', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  dot:    { width: 10, height: 10, borderRadius: '50%', background: COLORS.accent },
  label:  { display: 'block', fontWeight: 600, fontSize: 15 },
  hint:   { display: 'block', fontSize: 12, color: COLORS.textLight, marginTop: 2 },
};
